export default "__VITE_ASSET__eFWbF9nl__"